<script>
	import { convertDateTime, timeElapsed } from "src/services/helpers";
	import { cachedTaskLookups } from "src/store/store";
	import { splitCamelCaseAndCapitalize } from "src/utils/misc";
	import CustomDropdown from "../CustomDropdown/CustomDropdown.svelte";
	export let detailData;
	let { job, vehicle } = detailData;
</script>

<div class="d-flex">
	<div class="section-container half-w mx-1">
		<b class="my-2">Job Information</b>
		<div class="my-1 py-3 info-category">
			<div>
				<span class="category-name">Category</span>
			</div>
			<div>
				{#if $cachedTaskLookups.taskCategories}
					{#each job.categoryIds as categoryId, index}
						{splitCamelCaseAndCapitalize(
							$cachedTaskLookups.taskCategories[categoryId - 1]
								.name
						)}{#if index < Math.min(2, job.categoryIds.length - 1)},&nbsp;
						{/if}
					{/each}
				{/if}
			</div>
		</div>
		<div class="my-1 py-3 info-category">
			<div>
				<span class="category-name">Priority</span>
			</div>
			<div>
				<span>{job.priority}</span>
			</div>
		</div>
		<div class="my-1 py-3 info-category">
			<div>
				<span class="category-name">Assigned To</span>
			</div>
			<div>
				<span
					>{job.assignedTo?.group
						? job.assignedTo.group.name
						: job.assignedTo?.user
							? job.assignedTo.user.name
							: "-"}</span
				>
			</div>
		</div>
		<div class="my-1 py-3 info-category">
			<div>
				<span class="category-name">Mobile Number</span>
			</div>
			<div>
				<span
					>{job.assignedTo?.user
						? job.assignedTo.user.mobileNo
						: "-"}</span
				>
			</div>
		</div>
		<div class="my-1 py-3 info-category">
			<div>
				<span class="category-name">Due Date</span>
			</div>
			<div>
				<span>{convertDateTime(job.due)}</span>
			</div>
		</div>
		<div class="my-1 py-3">
			<div>
				<span class="category-name">Time Lapsed</span>
			</div>
			<div>
				<span>{timeElapsed(job.due)}</span>
			</div>
		</div>
	</div>
	<div class="section-container half-w mx-1">
		<b class="my-2">Car Information</b>
		<div class="my-1 py-3 info-category">
			<div>
				<span class="category-name">Vehicle Number</span>
			</div>
			<div>
				<span>{vehicle.plateNo}</span>
			</div>
		</div>
		<div class="my-1 py-3 info-category">
			<div>
				<span class="category-name">Car Color, Make & Model</span>
			</div>
			<div>
				<span
					>{`${vehicle.color}  ${vehicle.make} ${vehicle.model}`}</span
				>
			</div>
		</div>
		<div class="my-1 py-3 info-category">
			<div>
				<span class="category-name">Car Status</span>
			</div>
			<div>
				<CustomDropdown
					options={$cachedTaskLookups.vehicleStatuses}
					value={vehicle.statusId}
					isOpen={false}
					chevron={false}
					alignLeft
				/>
			</div>
		</div>
		<div class="my-1 py-3 info-category">
			<div>
				<span class="category-name">Carpark ID</span>
			</div>
			<div>
				<span>{vehicle.carparkId}</span>
			</div>
		</div>
		<div class="my-1 py-3 info-category">
			<div>
				<span class="category-name">Region</span>
			</div>
			<div>
				<span>{vehicle.region}</span>
			</div>
		</div>
		<div class="my-1 py-3 info-category">
			<div>
				<span class="category-name">Estate</span>
			</div>
			<div>
				<span>{vehicle.estate}</span>
			</div>
		</div>
		<div class="my-1 py-3">
			<div>
				<span class="category-name">Address</span>
			</div>
			<div>
				<span>{vehicle.address}</span>
			</div>
		</div>
	</div>
</div>

<style>
	.info-category {
		border-bottom: 1px solid #e8e8e8;
	}

	:global(.category-name) {
		color: var(--fds-on-surface-variant);
	}

	.half-w {
		width: 48%;
		height: fit-content;
	}
</style>
